export   const elAlData = [
    {
        "company name": "El Al Israel",
        "date": "11/27/2024",
        "price": 442,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "12/17/2024",
        "price": 630,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "01/23/2024",
        "price": 254,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "01/05/2024",
        "price": 151,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "11/29/2024",
        "price": 361,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "09/14/2024",
        "price": 578,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "02/02/2024",
        "price": 980,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "05/20/2024",
        "price": 1046,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "10/12/2024",
        "price": 107,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "06/24/2024",
        "price": 104,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "04/22/2024",
        "price": 490,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "03/26/2024",
        "price": 570,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "03/11/2024",
        "price": 1287,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "10/15/2024",
        "price": 744,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "07/18/2024",
        "price": 352,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "09/27/2024",
        "price": 309,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "06/14/2024",
        "price": 607,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "11/17/2024",
        "price": 564,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "06/07/2024",
        "price": 163,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "02/08/2024",
        "price": 1155,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "03/23/2024",
        "price": 711,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "10/20/2024",
        "price": 1199,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "08/19/2024",
        "price": 1013,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "10/16/2024",
        "price": 509,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "05/21/2024",
        "price": 204,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "02/18/2024",
        "price": 115,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "08/28/2024",
        "price": 146,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "08/19/2024",
        "price": 128,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "10/16/2024",
        "price": 579,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "08/14/2024",
        "price": 1220,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "09/02/2024",
        "price": 341,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "01/01/2024",
        "price": 277,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "04/14/2024",
        "price": 221,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "05/01/2024",
        "price": 203,
        "destination": "Madrid"
    },
    {
        "company name": "El Al Israel",
        "date": "10/10/2024",
        "price": 110,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "07/24/2024",
        "price": 423,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "07/27/2024",
        "price": 50,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "04/14/2024",
        "price": 297,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "01/12/2024",
        "price": 589,
        "destination": "Madrid"
    },
    {
        "company name": "El Al Israel",
        "date": "01/25/2024",
        "price": 76,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "10/30/2024",
        "price": 50,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "02/12/2024",
        "price": 183,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "11/10/2024",
        "price": 1668,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "10/18/2024",
        "price": 332,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "10/21/2024",
        "price": 722,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "10/19/2024",
        "price": 298,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "08/11/2024",
        "price": 1050,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "08/04/2024",
        "price": 673,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "11/30/2024",
        "price": 799,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "01/09/2024",
        "price": 1573,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "05/27/2024",
        "price": 374,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "11/06/2024",
        "price": 398,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "10/06/2024",
        "price": 1036,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "09/08/2024",
        "price": 996,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "07/10/2024",
        "price": 629,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "05/22/2024",
        "price": 231,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "04/04/2024",
        "price": 53,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "08/30/2024",
        "price": 839,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "05/06/2024",
        "price": 556,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "05/09/2024",
        "price": 1248,
        "destination": "Madrid"
    },
    {
        "company name": "El Al Israel",
        "date": "09/26/2024",
        "price": 411,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "02/27/2024",
        "price": 990,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "06/07/2024",
        "price": 478,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "11/29/2024",
        "price": 676,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "09/15/2024",
        "price": 539,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "04/29/2024",
        "price": 62,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "01/30/2024",
        "price": 336,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "09/10/2024",
        "price": 63,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "06/11/2024",
        "price": 457,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "11/21/2024",
        "price": 218,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "10/01/2024",
        "price": 353,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "11/28/2024",
        "price": 291,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "01/07/2024",
        "price": 778,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "04/03/2024",
        "price": 162,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "04/12/2024",
        "price": 549,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "02/09/2024",
        "price": 890,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "01/31/2024",
        "price": 1135,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "04/27/2024",
        "price": 904,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "11/09/2024",
        "price": 547,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "07/17/2024",
        "price": 88,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "12/19/2024",
        "price": 693,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "12/04/2024",
        "price": 156,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "06/02/2024",
        "price": 189,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "04/26/2024",
        "price": 1177,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "06/16/2024",
        "price": 791,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "07/14/2024",
        "price": 250,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "12/16/2024",
        "price": 523,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "03/28/2024",
        "price": 351,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "09/29/2024",
        "price": 728,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "02/24/2024",
        "price": 899,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "11/21/2024",
        "price": 751,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "01/12/2024",
        "price": 558,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "11/18/2024",
        "price": 119,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "02/27/2024",
        "price": 328,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "07/08/2024",
        "price": 50,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "02/17/2024",
        "price": 981,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "11/02/2024",
        "price": 546,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "05/22/2024",
        "price": 211,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "06/07/2024",
        "price": 216,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "08/23/2024",
        "price": 680,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "11/02/2024",
        "price": 670,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "03/18/2024",
        "price": 317,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "10/08/2024",
        "price": 376,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "10/21/2024",
        "price": 373,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "05/12/2024",
        "price": 186,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "10/24/2024",
        "price": 126,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "06/15/2024",
        "price": 224,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "04/26/2024",
        "price": 182,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "07/27/2024",
        "price": 58,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "05/06/2024",
        "price": 126,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "02/10/2024",
        "price": 214,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "02/23/2024",
        "price": 1698,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "06/28/2024",
        "price": 1056,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "10/22/2024",
        "price": 267,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "10/24/2024",
        "price": 1334,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "07/23/2024",
        "price": 407,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "06/28/2024",
        "price": 458,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "02/11/2024",
        "price": 308,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "11/02/2024",
        "price": 767,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "04/15/2024",
        "price": 1554,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "02/14/2024",
        "price": 492,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "05/02/2024",
        "price": 170,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "04/04/2024",
        "price": 542,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "03/31/2024",
        "price": 260,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "06/03/2024",
        "price": 834,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "12/04/2024",
        "price": 399,
        "destination": "Madrid"
    },
    {
        "company name": "El Al Israel",
        "date": "12/03/2024",
        "price": 163,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "12/14/2024",
        "price": 1036,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "10/28/2024",
        "price": 50,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "06/07/2024",
        "price": 350,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "09/30/2024",
        "price": 449,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "10/28/2024",
        "price": 911,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "12/13/2024",
        "price": 390,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "04/30/2024",
        "price": 979,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "04/05/2024",
        "price": 637,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "10/07/2024",
        "price": 50,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "03/03/2024",
        "price": 1201,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "09/25/2024",
        "price": 1090,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "10/03/2024",
        "price": 759,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "06/17/2024",
        "price": 577,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "04/08/2024",
        "price": 165,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "01/07/2024",
        "price": 247,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "02/16/2024",
        "price": 98,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "02/12/2024",
        "price": 683,
        "destination": "Madrid"
    },
    {
        "company name": "El Al Israel",
        "date": "06/05/2024",
        "price": 1001,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "01/14/2024",
        "price": 322,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "03/27/2024",
        "price": 511,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "06/07/2024",
        "price": 460,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "05/29/2024",
        "price": 50,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "06/13/2024",
        "price": 1219,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "03/22/2024",
        "price": 501,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "11/21/2024",
        "price": 627,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "07/07/2024",
        "price": 50,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "10/08/2024",
        "price": 623,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "04/22/2024",
        "price": 112,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "09/06/2024",
        "price": 628,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "02/01/2024",
        "price": 1224,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "01/03/2024",
        "price": 427,
        "destination": "Madrid"
    },
    {
        "company name": "El Al Israel",
        "date": "09/22/2024",
        "price": 943,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "12/18/2024",
        "price": 150,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "09/30/2024",
        "price": 327,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "12/30/2024",
        "price": 264,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "04/29/2024",
        "price": 191,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "12/06/2024",
        "price": 1025,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "06/25/2024",
        "price": 1296,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "11/13/2024",
        "price": 825,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "03/09/2024",
        "price": 572,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "10/21/2024",
        "price": 704,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "02/22/2024",
        "price": 187,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "08/29/2024",
        "price": 82,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "07/06/2024",
        "price": 1104,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "06/10/2024",
        "price": 507,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "08/06/2024",
        "price": 645,
        "destination": "Madrid"
    },
    {
        "company name": "El Al Israel",
        "date": "07/31/2024",
        "price": 431,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "10/30/2024",
        "price": 165,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "06/03/2024",
        "price": 1247,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "10/05/2024",
        "price": 971,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "04/15/2024",
        "price": 50,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "05/11/2024",
        "price": 1038,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "08/12/2024",
        "price": 144,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "04/14/2024",
        "price": 155,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "08/21/2024",
        "price": 702,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "12/01/2024",
        "price": 655,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "07/20/2024",
        "price": 336,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "10/08/2024",
        "price": 272,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "08/26/2024",
        "price": 429,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "05/11/2024",
        "price": 683,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "06/30/2024",
        "price": 730,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "02/05/2024",
        "price": 285,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "11/11/2024",
        "price": 753,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "05/31/2024",
        "price": 106,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "03/20/2024",
        "price": 264,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "09/15/2024",
        "price": 602,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "12/01/2024",
        "price": 254,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "08/15/2024",
        "price": 1360,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "11/13/2024",
        "price": 818,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "10/01/2024",
        "price": 1153,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "01/30/2024",
        "price": 974,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "05/09/2024",
        "price": 571,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "06/29/2024",
        "price": 1269,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "04/12/2024",
        "price": 1203,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "06/08/2024",
        "price": 1418,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "06/12/2024",
        "price": 1420,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "05/09/2024",
        "price": 273,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "04/01/2024",
        "price": 917,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "11/29/2024",
        "price": 196,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "03/01/2024",
        "price": 50,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "02/26/2024",
        "price": 73,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "04/24/2024",
        "price": 400,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "09/04/2024",
        "price": 78,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "07/10/2024",
        "price": 1088,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "10/03/2024",
        "price": 192,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "11/17/2024",
        "price": 583,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "07/31/2024",
        "price": 372,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "02/25/2024",
        "price": 472,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "08/16/2024",
        "price": 74,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "12/02/2024",
        "price": 419,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "02/16/2024",
        "price": 111,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "11/07/2024",
        "price": 858,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "10/26/2024",
        "price": 924,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "12/20/2024",
        "price": 374,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "09/14/2024",
        "price": 543,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "04/12/2024",
        "price": 50,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "03/19/2024",
        "price": 1105,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "05/27/2024",
        "price": 717,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "12/19/2024",
        "price": 266,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "11/09/2024",
        "price": 77,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "01/07/2024",
        "price": 50,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "09/21/2024",
        "price": 128,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "01/01/2024",
        "price": 103,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "10/13/2024",
        "price": 1075,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "06/05/2024",
        "price": 491,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "04/12/2024",
        "price": 568,
        "destination": "Madrid"
    },
    {
        "company name": "El Al Israel",
        "date": "06/05/2024",
        "price": 904,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "03/07/2024",
        "price": 946,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "11/12/2024",
        "price": 50,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "06/02/2024",
        "price": 587,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "09/04/2024",
        "price": 1093,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "01/30/2024",
        "price": 1218,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "12/29/2024",
        "price": 780,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "01/22/2024",
        "price": 483,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "10/18/2024",
        "price": 1056,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "06/10/2024",
        "price": 308,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "05/04/2024",
        "price": 220,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "09/21/2024",
        "price": 473,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "11/03/2024",
        "price": 418,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "05/09/2024",
        "price": 365,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "09/27/2024",
        "price": 267,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "05/29/2024",
        "price": 143,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "03/13/2024",
        "price": 270,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "12/30/2024",
        "price": 774,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "08/30/2024",
        "price": 179,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "06/17/2024",
        "price": 813,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "12/14/2024",
        "price": 516,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "01/14/2024",
        "price": 85,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "04/20/2024",
        "price": 268,
        "destination": "Chicago"
    },
    {
        "company name": "El Al Israel",
        "date": "03/14/2024",
        "price": 715,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "07/02/2024",
        "price": 1065,
        "destination": "Bangkok"
    },
    {
        "company name": "El Al Israel",
        "date": "01/02/2024",
        "price": 897,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "10/18/2024",
        "price": 784,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "10/21/2024",
        "price": 321,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "06/20/2024",
        "price": 947,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "02/11/2024",
        "price": 408,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "02/01/2024",
        "price": 457,
        "destination": "Madrid"
    },
    {
        "company name": "El Al Israel",
        "date": "08/12/2024",
        "price": 390,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "02/14/2024",
        "price": 599,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "07/31/2024",
        "price": 432,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "09/10/2024",
        "price": 728,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "11/23/2024",
        "price": 543,
        "destination": "Los Angeles"
    },
    {
        "company name": "El Al Israel",
        "date": "12/21/2024",
        "price": 626,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "09/14/2024",
        "price": 970,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "09/05/2024",
        "price": 329,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "07/23/2024",
        "price": 191,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "03/17/2024",
        "price": 958,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "12/13/2024",
        "price": 169,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "09/03/2024",
        "price": 1393,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "04/20/2024",
        "price": 269,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "10/08/2024",
        "price": 361,
        "destination": "Tokyo"
    },
    {
        "company name": "El Al Israel",
        "date": "06/30/2024",
        "price": 77,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "10/21/2024",
        "price": 237,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "07/03/2024",
        "price": 117,
        "destination": "Madrid"
    },
    {
        "company name": "El Al Israel",
        "date": "07/20/2024",
        "price": 89,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "03/09/2024",
        "price": 1088,
        "destination": "Moscow"
    },
    {
        "company name": "El Al Israel",
        "date": "07/21/2024",
        "price": 293,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "07/21/2024",
        "price": 630,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "07/30/2024",
        "price": 414,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "02/29/2024",
        "price": 756,
        "destination": "Dubai"
    },
    {
        "company name": "El Al Israel",
        "date": "03/15/2024",
        "price": 1115,
        "destination": "Singapore"
    },
    {
        "company name": "El Al Israel",
        "date": "12/04/2024",
        "price": 180,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "09/10/2024",
        "price": 295,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "10/02/2024",
        "price": 1051,
        "destination": "New York"
    },
    {
        "company name": "El Al Israel",
        "date": "11/21/2024",
        "price": 949,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "05/05/2024",
        "price": 453,
        "destination": "Sydney"
    },
    {
        "company name": "El Al Israel",
        "date": "06/01/2024",
        "price": 291,
        "destination": "Paris"
    },
    {
        "company name": "El Al Israel",
        "date": "01/01/2024",
        "price": 977,
        "destination": "Toronto"
    },
    {
        "company name": "El Al Israel",
        "date": "03/18/2024",
        "price": 1274,
        "destination": "Beijing"
    },
    {
        "company name": "El Al Israel",
        "date": "06/03/2024",
        "price": 94,
        "destination": "London"
    },
    {
        "company name": "El Al Israel",
        "date": "09/12/2024",
        "price": 290,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "01/16/2024",
        "price": 631,
        "destination": "Hong Kong"
    },
    {
        "company name": "El Al Israel",
        "date": "07/15/2024",
        "price": 519,
        "destination": "London"
    }
]
